import React, { useEffect, useRef, useState } from 'react';
import { View, Platform, ActivityIndicator, Linking } from 'react-native';
import { WebView } from 'react-native-webview';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '@app/navigationApp/types';
import ROUTE from '@app/navigationApp/routes';
import { endpoints } from '@app/api/apis';
import axios from 'axios';
import { trackEvent } from '@app/utils';
import { PaymentStatuses } from './ConfirmPay/ConfirmPay';
import { themeColorSet } from '@app/theme';

type PaymentWebViewProps = NativeStackScreenProps<PrivateStackParamList, 'PAYMENT_WEBVIEW'>;

const PaymentWebView: React.FC<PaymentWebViewProps> = ({ route, navigation }) => {
    const { uri,doFormPost } = route.params;
    const webViewRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);

    const onShouldStartLoadWithRequest = (event: any) => {
		const { url } = event;
        console.warn("EVENT RECEIVED IS", event)
        if(url.includes("showFlexi") || url === "https://app.voltmoney.in/mandateCallback?redirect=true&showVoltDefaultHeader=false"){
            navigation.navigate(ROUTE.FLEXI_PAY);
            
            return false
        } else {
            if (url.startsWith("upi://") || url.includes("upi://") || url.includes("tez") || url.includes("paytmmp") ||url.includes("phonepe")  || url.includes("credpay") || url.includes("bhim")) {
                try {
                    Linking.openURL(url);
                } catch (error) {
                    console.error('Error opening start UPI link:');
                }
                return false;
                } else {
                return true
            }
        }
	  };

    const handleNavigationStateChange = async (navState: any) => {
        const { url } = navState;
        if (url.startsWith('upi://') || url.includes('upi://')) {
            try {
                const supported = await Linking.canOpenURL(url);
                if (supported) {
                    await Linking.openURL(url);
                }
            } catch (error) {
                console.error('Error opening UPI link:', error);
            }
        }
    };

    const htmlContent = `
        <html>
        <body onload="document.forms[0].submit()">
            <form method="POST" action="https://payment.bajajfinserv.in/Paymentgateway/Payments/Direct_Loan_Payment">
                <input type="hidden" name="msg" value="${uri}" />
            </form>
        </body>
        </html>
    `;

    const handleNavigationStateChangePayment = async (navState: any) => {
		const { url } = navState;
	
		if (url.startsWith("upi://") || url.includes("upi://")) {
		  try {
			const supported = await Linking.canOpenURL(url);
			if (supported) {
			  await Linking.openURL(url);
			} else {
				console.error('Error opening UPI link:');
			}
		  } catch (error) {
			console.error('Error opening UPI link:');
		  }
		}
	  };

    if (doFormPost) {
        return (
            <View style={{ flex: 1 }}>
                {isLoading && (
                    <View style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 10,
                    }}>
                        <ActivityIndicator
                            color={themeColorSet['icon-primary']}
                            size="large"
                        />
                    </View>
                )}
                <View style={{ flex: 1}}>
                    <WebView
                        ref={webViewRef}
                        style={{ flex: 1, height: '100%', borderWidth:1 , borderColor: 'red' }}
					automaticallyAdjustContentInsets={false}
					javaScriptEnabled={true}
					domStorageEnabled={true}
					startInLoadingState={false} 
					useWebKit={true}
					originWhitelist={['*']}
					allowsInlineMediaPlayback={true}
					scalesPageToFit={Platform.OS === 'android'}
					scrollEnabled={true}
					onNavigationStateChange={handleNavigationStateChangePayment}
                    onShouldStartLoadWithRequest={onShouldStartLoadWithRequest}
					javaScriptEnabledAndroid={true}
					mediaPlaybackRequiresUserAction={false}
					source={{ html: htmlContent }}
					showsHorizontalScrollIndicator={false}
					nestedScrollEnabled={Platform.OS !== 'web'}
					incognito={true}
					mixedContentMode="always"
					onLoadStart={() =>{
						setIsLoading(true)
					} } 
					onLoadEnd={() => {
						setIsLoading(false)
					}}
                    />
                </View>
            </View>
        );
    }

    return (
        <View style={{ flex: 1 }}>
            <WebView
                ref={webViewRef}
                style={{ flex: 1 }}
                source={{ uri }}
                onNavigationStateChange={handleNavigationStateChange}
                javaScriptEnabled={true}
                domStorageEnabled={true}
                startInLoadingState={true}
                scalesPageToFit={Platform.OS === 'android'}
                showsHorizontalScrollIndicator={false}
                nestedScrollEnabled={true}
                incognito={false}
                mixedContentMode="always"
            />
        </View>
    );
};

export default PaymentWebView; 